import React, { Component } from "react";
import Page from '../../Page';
import Intro from '../../components/Intro/Intro.js';
import Quote from '../../components/Quote/Quote.js';
import Text from '../../components/Text/Text';
import DocumentMeta from 'react-document-meta';
import TextFullImage from '../../components/TextFullImage/TextFullImage.js';
import fullimageImage from '../../img/ramon-deenen-2.jpg';
import quoteImage from '../../img/ramon-deenen-1.jpg';
import FullWidthImage from '../../components/FullWidthImage/FullWidthImage';
import fullWidthImg from '../../img/Brauwer-graus.jpg';
import data from '../../components/magazine.json';
import PageNumber from "../../components/PageNumber/PageNumber";
import Share from "../../components/Share/Share";
import MetaTags from "react-meta-tags";

const introtekst = data.magazine.pages[1]["intro-text"];

const quote = data.magazine.pages[1].quote;
const author = data.magazine.pages[1].author;
const website = data.magazine.pages[1].website;

const title =  data.magazine.pages[1].title;
const paragraphs1 = data.magazine.pages[1]["paragraphs-first-part"];
const paragraphs2 = data.magazine.pages[1]["paragraphs-second-part"];

class Thirdpage extends Component {
  componentDidMount(){
    const prevLink = '/appart-me/editie-9/astrael-is-anders-met-ambitie-en-dromen';
    const nextLink = '/appart-me/editie-9/een-andere-kijk-op-een-duurzame-toekomst';
    const prevPossible = true;
    const nextPossible = true;
    const isScrollable = true;
    this.props.updatelinks(prevLink, nextLink, prevPossible, nextPossible, isScrollable);
  }

  render() {
    console.log(data);
    const meta = {
      title: 'Appart Me | Editie 9 | ' + author + ' | ' + data.magazine.pages[1]["intro-title"] ,
    };
    return (
      <Page>
        <MetaTags>
          <title>{ meta.title }</title>
          <meta name="description" content="Duurzaamheid kent geen tijd: Brauer Groen over de volgende stap in groenbeheer" />
          <meta name="og:title" content="Duurzaamheid kent geen tijd: Brauer Groen over de volgende stap in groenbeheer" />
          <meta name="og:description" content="Duurzaamheid kent geen tijd: Brauer Groen over de volgende stap in groenbeheer" />
          <meta name="og:image" content={"https://appart.nl/" + fullimageImage} />
          <meta name="twitter:image" content={"https://appart.nl/" + fullimageImage} />
        </MetaTags>
        <Intro title={data.magazine.pages[1]["intro-title"]} subtitle={data.magazine.pages[1]["intro-sub-title"]} content={introtekst} background={fullimageImage}/>
        <TextFullImage title={title} paragraphs={paragraphs1} image={fullimageImage} alt="papegaai"/>
        <FullWidthImage image={fullWidthImg} />
        <Text paragraphs={paragraphs2} />
          <Share />
        <Quote quote={quote} author={author} website={website} classes='quote-block' image={quoteImage}/>
        <PageNumber pageNumber={4} />
      </Page>
    )
  }
}

export default Thirdpage;
